import { createSlice } from '@reduxjs/toolkit'
import { checkoutAPI } from '../actions/checkout-actions'

export type CheckOut = {
  success: boolean
  loading: boolean
  message?: string | null
}

const initialState: CheckOut = {
  success: false,
  loading: false,
  message: null
}

export const checkoutSlices = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    // getAllProducts: async () => {
    //   const data = await fetchProducts()
    // },
  },
  extraReducers: builders => {
    builders
      // CHECKOUT API
      .addCase(checkoutAPI.fulfilled, (state, action) => {
        state.success = action.payload.success
        state.message = action.payload.message
        state.loading = false
      })
      .addCase(checkoutAPI.pending, state => {
        state.loading = true
      })
      .addCase(checkoutAPI.rejected, (state, action) => {
        state.success = action.payload?.success || false
        state.message = action.payload?.message
        state.loading = false
      })
  }
})

export const all = checkoutSlices.actions

export default checkoutSlices.reducer
